import {on} from 'delegated-events';

export default function headMenu() {
  const header = 'data-headmenu';
  const ariaPressed = 'aria-pressed';
  const hamburgerElem = document.querySelector(`[${header}]`);
  const breakpoint = window.matchMedia('(max-width: 42.5em)');

  const media = () => {
    if (breakpoint.matches) {
      hamburgerElem.setAttribute(header, 'shown');
    } else {
      hamburgerElem.setAttribute(header, 'hidden');
      hamburgerElem.setAttribute(ariaPressed, 'false');
    }
  };

  media();
  breakpoint.addListener(media);

  on('click', `[${header}]`, (event) => {
    event.preventDefault();

    if (hamburgerElem.getAttribute(ariaPressed) === 'false') {
      hamburgerElem.setAttribute(ariaPressed, 'true');
    } else {
      hamburgerElem.setAttribute(ariaPressed, 'false');
    }
  });
}
